import React, {useEffect, useState} from 'react';
import BadgeCore from './BadgeCore';

export default function ContinueToGiveBadge({value}) {
  return <BadgeCore value={value} type="show_donation_badge" />;
}
